/**
 * LiveReportsScreen — primary adapter for the parent "Rapports" tab.
 *
 * Wires: useLiveReportsData (fetch + page cursor) + liveReportsViewModel (pure map) +
 * useLiveReportsState (UI interactions) → DS `<LiveReportsListPage>`.
 */
import React from "react"
import { useSelector } from "react-redux"

import { LiveReportsListPage } from "../../../../../../design-system"
import { liveReportsViewModel } from "../../../../view-models/parent/LiveReports/liveReportsViewModel"
import { useLiveReportsData } from "./useLiveReportsData"
import { useLiveReportsState } from "./useLiveReportsState"

export type LiveReportsScreenProps = {
    /** From ParentTabScreenWrapper / parent shell — the selected child. */
    selectedUser?: { userId?: string | number } | null
}

export function LiveReportsScreen(props: LiveReportsScreenProps) {
    const studentId = props.selectedUser?.userId
    const { refresh, loadMore, hasMore, totalCount } = useLiveReportsData(studentId)
    const vm = useSelector(liveReportsViewModel)
    const { actions } = useLiveReportsState()

    return (
        <LiveReportsListPage
            reports={vm.reports}
            loading={vm.loading}
            refreshing={vm.refreshing}
            loadingMore={vm.loadingMore}
            loadMoreError={vm.loadMoreError}
            hasMore={hasMore}
            totalCount={totalCount}
            error={vm.error}
            onRetry={refresh}
            onRefresh={refresh}
            onLoadMore={loadMore}
            onOpenReport={actions.openReport}
        />
    )
}

export default LiveReportsScreen
